/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */

import * as React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import { datadogRum } from "@datadog/browser-rum";

import * as API from "../../../../api/billing";
import {
  StyledButton,
  StyledButtonContainer,
  StyledModalBody,
  StyledParagraph,
  StyledModalContents,
} from "../lib/styles";
import { SwitchToAnnualModalBodyProps } from "../lib/types";

const SwitchToAnnualModalBody = ({
  closeModal,
  fetchData,
  updateToastMessage,
}: SwitchToAnnualModalBodyProps): React.ReactElement => {
  const handleSwitchToAnnual = async (): Promise<void> => {
    try {
      await API.updateToAnnual();

      updateToastMessage({
        isOpen: true,
        message: i18n.translate(
          "admin_pages.settings.subscription.switch_to_annual_confirmation"
        ),
        type: "success",
      });
      fetchData();
      closeModal();
    } catch (error) {
      datadogRum.addError(error);
      updateToastMessage({
        isOpen: true,
        message: i18n.translate(
          "admin_pages.settings.subscription.switch_to_annual_error"
        ),
        type: "error",
      });
    }
  };

  return (
    <StyledModalBody data-testid="switch-to-annual-modal-body">
      <StyledModalContents>
        <StyledParagraph>
          {i18n.translate(
            "admin_pages.settings.subscription.switch_to_annual_modal_text"
          )}
        </StyledParagraph>
      </StyledModalContents>

      <StyledButtonContainer>
        <StyledButton
          onClick={closeModal}
          size="small"
          testId="cancel-button"
          variant="secondary"
        >
          {i18n.translate("forms.cancel")}
        </StyledButton>
        <StyledButton
          onClick={handleSwitchToAnnual}
          size="small"
          testId="update-button"
          variant="primary"
        >
          {i18n.translate("forms.update")}
        </StyledButton>
      </StyledButtonContainer>
    </StyledModalBody>
  );
};

export default SwitchToAnnualModalBody;
